import {retraiteBDL} from '../bdl/retraite';

export const retraiteService = () => ({...retraiteBDL()});
